var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGetpaid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104 107",
    style: {
      enableBackground: "new 0 0 104 107"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2C80C3;}\r\n\t.st1{fill:#FFDAAB;}\r\n\t.st2{fill:#FDC478;}\r\n\t.st3{fill:#FCB557;}\r\n\t.st4{fill:#FFDE56;}\r\n\t.st5{fill:#F26347;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    className: "st0",
    d: "M16.9,106.5V72.2H3.1v34.3H16.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    className: "st1",
    d: "M100.7,64.8l-2.4-2.4c-2-2-5.3-2-7.3,0L73.4,80v-6c0-1.9-1.5-3.4-3.4-3.4H25.4l-8.6,8.6v24 l8.6-8.6h48l27.3-27.3C101.4,66.5,101.4,65.4,100.7,64.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    className: "st2",
    d: "M82,70.5v-6.9H54.6v6.9H82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    className: "st3",
    d: "M83.7,63.6v-6.9H56.3v6.9H83.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "st2",
    d: "M82,49.9H54.6v6.9H82V49.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    className: "st3",
    d: "M49.4,63.6H22v6.9h27.4V63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st2",
    d: "M47.7,56.8H20.3v6.9h27.4V56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "st3",
    d: "M49.4,56.8v-6.9H22v6.9H49.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st2",
    d: "M51.2,49.9V43H23.7v6.9H51.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "st3",
    d: "M47.7,36.2H20.3V43h27.4V36.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st2",
    d: "M49.4,36.2v-6.9H22v6.9H49.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st4",
    d: "M92.3,27.6c0,7.6-6.1,13.7-13.7,13.7c-7.6,0-13.7-6.1-13.7-13.7S71,13.9,78.6,13.9 C86.2,13.9,92.3,20,92.3,27.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st5",
    d: "M78.6,25.9c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7h3.4 c0-2.2-1.4-4.1-3.4-4.8v-2h-3.4v2c-2.7,0.9-4.1,3.9-3.1,6.5c0.7,2.1,2.7,3.4,4.9,3.4c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7 c-0.9,0-1.7-0.8-1.7-1.7h-3.4c0,2.2,1.4,4.1,3.4,4.8v2h3.4v-2c2.7-0.9,4.1-3.9,3.1-6.5C82.7,27.3,80.8,25.9,78.6,25.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st2",
    d: "M47.7,79.1h25.7v1.7H47.7V79.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetpaid);
export default __webpack_public_path__ + "static/media/getpaid.9f87570e083b6c5968cbe7944f2fd2cd.svg";
export { ForwardRef as ReactComponent };